import React, { lazy, Suspense, useEffect, useState } from 'react';
import { fetchPublicConfig, isStaticSiteEnabled } from './shared/publicConfig';

// Code-split the two front-ends so the user only downloads the bundle they
// actually render. Each sub-app owns its own providers, routes, and styles.
const DynamicApp = lazy(() => import('./apps/dynamic/App'));
const StaticApp = lazy(() => import('./apps/static/App'));

const Splash = () => (
  <div
    style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#fafafa',
    }}
  >
    <div
      style={{
        width: 40,
        height: 40,
        border: '3px solid #e5e7eb',
        borderTopColor: '#db2777',
        borderRadius: '50%',
        animation: 'rootswitch-spin 0.8s linear infinite',
      }}
    />
    <style>{`@keyframes rootswitch-spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

const isAdminPath = () =>
  typeof window !== 'undefined' &&
  window.location.pathname.startsWith('/admin');

const RootSwitch = () => {
  // Admin routes always render the dynamic app — that's how admins flip the
  // static/dynamic flag in the first place, so it must never depend on the
  // public config response.
  const adminEscape = isAdminPath();

  const [mode, setMode] = useState(adminEscape ? 'dynamic' : null);

  useEffect(() => {
    if (adminEscape) return;
    let cancelled = false;
    (async () => {
      const config = await fetchPublicConfig();
      if (cancelled) return;
      setMode(isStaticSiteEnabled(config) ? 'static' : 'dynamic');
    })();
    return () => {
      cancelled = true;
    };
  }, [adminEscape]);

  if (!mode) return <Splash />;

  return (
    <Suspense fallback={<Splash />}>
      {mode === 'static' ? <StaticApp /> : <DynamicApp />}
    </Suspense>
  );
};

export default RootSwitch;
